import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "component-shadow-picker" }
const _hoisted_2 = { class: "shadow-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "阴影颜色:", -1)
const _hoisted_4 = { class: "shadow-component" }
const _hoisted_5 = { class: "shadow-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "阴影大小:", -1)
const _hoisted_7 = { class: "shadow-component" }
const _hoisted_8 = { class: "shadow-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "阴影模糊:", -1)
const _hoisted_10 = { class: "shadow-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_a_slider = _resolveComponent("a-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_color_picker, {
          value: _ctx.values[3],
          onChange: _cache[0] || (_cache[0] = 
            v => {
              _ctx.updateValue(v, 3)
            }
          )
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_slider, {
          value: parseInt(_ctx.values[0]),
          min: 0,
          max: 20,
          onChange: _cache[1] || (_cache[1] = 
            v => {
              _ctx.updateValue(v, [0, 1])
            }
          )
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_slider, {
          value: parseInt(_ctx.values[2]),
          min: 0,
          max: 20,
          onChange: _cache[2] || (_cache[2] = 
            v => {
              _ctx.updateValue(v, 2)
            }
          )
        }, null, 8, ["value"])
      ])
    ])
  ]))
}